<template xmlns="">
  <v-card dark class="d-flex flex-column" style="background-color: #121212; min-height: 100vh; border-radius: 0">
    <v-toolbar dark color="#1a1a1a" flat style="border-bottom: 1px solid #2a2a2a; position: sticky; top: 0; z-index: 100">
      <v-btn icon @click="checkChanges">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="text-h6 font-weight-bold white--text ml-2 tracking-wide">
        {{ exerciseEdit ? "Übung bearbeiten" : "Neue Übung" }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="#00E676" height="36" class="black--text font-weight-bold px-6 tracking-wide" depressed @click="validateForm"> SPEICHERN </v-btn>
    </v-toolbar>

    <div style="overflow-y: auto; flex-grow: 1; padding-bottom: 100px">
      <div style="background-color: #121212; padding: 24px 0">
        <v-card dark color="transparent" class="elevation-0 mx-auto" max-width="900">
          <div class="slim-wrapper">
            <slim-cropper v-if="loaded" style="height: 350px; width: 100%; border-radius: 8px; overflow: hidden" :options="slimOptionsExercise">
              <img v-if="form.picture" :src="'/img/uebungen/' + form.picture" alt="" />
              <input type="file" accept="image/*" />
            </slim-cropper>
          </div>
          <div
            v-if="!form.picture && loaded"
            class="text-center pa-8 grey--text"
            style="
              border: 1px dashed #333;
              border-radius: 8px;
              margin-top: -350px;
              height: 350px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              pointer-events: none;
            ">
            <v-icon large color="grey darken-2" class="mb-2">mdi-camera-plus</v-icon>
            <span>Tippe hier, um ein Übungsbild hochzuladen</span>
          </div>
        </v-card>
      </div>

      <v-form ref="form" lazy-validation @submit.prevent="preventReload" class="pa-4 mx-auto" style="max-width: 900px">
        <div class="mb-8">
          <h2 class="white--text font-weight-bold text-h5 mb-4 d-flex align-center">
            <v-icon color="#00E676" class="mr-2">mdi-dumbbell</v-icon> Grunddaten
          </h2>
          <v-text-field
            label="Übungstitel"
            v-model="form.title"
            :rules="rules.title"
            counter="30"
            outlined
            dense
            dark
            background-color="#1a1a1a"
            class="modern-input font-weight-medium mb-2"></v-text-field>

          <v-select
            v-if="availableTags"
            v-model="form.tags"
            :items="availableTags"
            deletable-chips
            return-object
            item-value="_id"
            item-text="name"
            multiple
            label="Tags (z.B. Brust, Bizeps...)"
            outlined
            dense
            dark
            background-color="#1a1a1a"
            class="modern-input">
            <template v-slot:selection="{ item }">
              <v-chip
                dark
                small
                color="#00E676"
                class="black--text font-weight-bold mt-1 mr-1"
                close
                close-icon="mdi-close-circle"
                @click:close="form.tags.splice(form.tags.indexOf(item), 1)">
                {{ item.name }}
              </v-chip>
            </template>
          </v-select>
        </div>

        <v-divider dark style="border-color: #2a2a2a" class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h5 d-flex align-center">
              <v-icon color="#00E676" class="mr-2">mdi-format-list-numbered</v-icon> Anleitung
            </h2>
            <v-btn color="#00E676" class="black--text px-4 font-weight-bold tracking-wide" depressed small @click="openManualDialog(-1)">
              <v-icon left small>mdi-plus</v-icon> SCHRITT
            </v-btn>
          </div>

          <div
            v-if="!form.manual || form.manual.length === 0"
            class="text-center pa-6 grey--text darken-1 text-subtitle-1"
            style="border: 1px dashed #333; border-radius: 6px">
            Noch keine Schritte hinzugefügt.
          </div>

          <v-card
            v-for="(manual, index) in form.manual"
            :key="index + 'manual'"
            dark
            color="#1a1a1a"
            class="mb-3 d-flex flex-row align-center elevation-0"
            style="border: 1px solid #2a2a2a; border-radius: 6px">
            <div
              style="width: 80px; height: 80px; background-color: #121212; border-radius: 6px 0 0 6px; overflow: hidden; position: relative"
              class="d-flex justify-center align-center">
              <v-img v-if="manual.picture" :src="'/img/uebungen/' + manual.picture" cover height="100%" width="100%"></v-img>
              <v-icon v-else color="grey darken-2">mdi-image</v-icon>
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: #00e676;
                  color: black;
                  padding: 2px 8px;
                  font-weight: bold;
                  font-size: 14px;
                  border-bottom-right-radius: 6px;
                ">
                {{ index + 1 }}
              </div>
            </div>
            <div class="pa-4 flex-grow-1">
              <div class="text-subtitle-1 white--text font-weight-medium">{{ manual.description || "Keine Beschreibung" }}</div>
            </div>
            <div class="pa-4 d-flex">
              <v-btn color="blue" outlined small class="mr-2 text-caption font-weight-bold" @click="openManualDialog(index)">
                <v-icon left small>mdi-pencil</v-icon> BEARBEITEN
              </v-btn>
            </div>
          </v-card>
        </div>

        <v-divider dark style="border-color: #2a2a2a" class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h5 d-flex align-center"><v-icon color="#00E676" class="mr-2">mdi-cog</v-icon> Gerät</h2>
            <v-btn
              color="#00E676"
              class="black--text px-4 font-weight-bold tracking-wide"
              depressed
              small
              @click="generalExerciseSettingsDialog = true">
              <v-icon left small>mdi-plus</v-icon> SETTING
            </v-btn>
          </div>

          <div
            v-if="!form.general_exercise_settings || form.general_exercise_settings.length === 0"
            class="text-center pa-6 grey--text darken-1 text-subtitle-1 mb-4"
            style="border: 1px dashed #333; border-radius: 6px">
            Keine Geräteeinstellungen vorhanden.
          </div>

          <v-row class="ma-0">
            <v-col cols="12" md="6" v-for="(setting, index) in form.general_exercise_settings" :key="index + 'g-setting'" class="pa-1">
              <v-card
                dark
                color="#1a1a1a"
                class="pa-3 elevation-0 d-flex justify-space-between align-center"
                style="border: 1px solid #2a2a2a; border-radius: 6px; border-left: 4px solid #1976d2">
                <div>
                  <div class="text-subtitle-1 font-weight-bold white--text">{{ setting.text }}</div>
                  <div class="text-caption grey--text">
                    {{ setting.input }} <span v-if="setting.selections && setting.selections.length">({{ setting.selections.length }} Optionen)</span>
                  </div>
                </div>
                <v-btn color="red" outlined small style="min-width: 36px; padding: 0" @click="deleteExerciseSetting(setting, 0, 'Device')">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <v-divider dark style="border-color: #2a2a2a" class="my-6"></v-divider>

        <div class="mb-8">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="white--text font-weight-bold text-h5 d-flex align-center"><v-icon color="#00E676" class="mr-2">mdi-repeat</v-icon> Sätze</h2>
            <v-btn color="#00E676" class="black--text px-4 font-weight-bold tracking-wide" depressed small @click="setExerciseSettingsDialog = true">
              <v-icon left small>mdi-plus</v-icon> SETTING
            </v-btn>
          </div>

          <div
            v-if="!form.set_exercise_settings || form.set_exercise_settings.length === 0"
            class="text-center pa-6 grey--text darken-1 text-subtitle-1 mb-4"
            style="border: 1px dashed #333; border-radius: 6px">
            Keine Satzeinstellungen vorhanden.
          </div>

          <v-row class="ma-0">
            <v-col cols="12" md="6" v-for="(setting, index) in form.set_exercise_settings" :key="index + 's-setting'" class="pa-1">
              <v-card
                dark
                color="#1a1a1a"
                class="pa-3 elevation-0 d-flex justify-space-between align-center"
                style="border: 1px solid #2a2a2a; border-radius: 6px; border-left: 4px solid #00e676">
                <div>
                  <div class="text-subtitle-1 font-weight-bold white--text">{{ setting.text }}</div>
                  <div class="text-caption grey--text">{{ setting.input }}</div>
                </div>
                <v-btn color="red" outlined small style="min-width: 36px; padding: 0" @click="deleteExerciseSetting(setting, 0, 'set')">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </div>

    <v-dialog v-model="manualDialog" max-width="600px" dark persistent>
      <v-card color="#1a1a1a" style="border-radius: 8px">
        <v-toolbar dark color="#121212" flat>
          <v-toolbar-title class="text-h6 font-weight-bold white--text">{{ getManualFormTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="abortManual"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-card dark color="transparent" class="elevation-0 mx-auto mb-6 slim-wrapper" style="border: 1px dashed #333; border-radius: 6px">
            <slim-cropper
              :key="manualForm.picture"
              v-if="loaded"
              style="height: 250px; width: 100%; border-radius: 6px; overflow: hidden"
              :options="slimOptionsManual">
              <img v-if="manualForm.picture" :src="'/img/uebungen/' + manualForm.picture" alt="" />
              <input type="file" accept="image/*" />
            </slim-cropper>
          </v-card>
          <v-text-field
            v-model="manualForm.description"
            label="Beschreibung des Schrittes"
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input"
            @keydown.enter.prevent="saveManual"></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-btn v-if="manualForm.index >= 0" color="red" outlined small @click="deleteManual">Löschen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey" text small @click="abortManual">Abbrechen</v-btn>
          <v-btn color="#00E676" class="black--text font-weight-bold px-4" depressed small @click="saveManual">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="generalExerciseSettingsDialog" max-width="600px" dark persistent>
      <v-card color="#1a1a1a" style="border-radius: 8px">
        <v-card-title class="text-h6 font-weight-bold white--text pt-5">Geräteeinstellung</v-card-title>
        <v-card-text class="pt-4">
          <v-combobox
            v-model="exerciseSetting"
            :search-input.sync="exerciseSettingSearch"
            item-text="text"
            return-object
            item-value="text"
            label="Was wird eingestellt? (z.B. Sitz)"
            :items="availableDeviceExerciseSettingsFiltered"
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input mb-2"></v-combobox>
          <v-select
            v-if="exerciseSetting.text"
            v-model="exerciseSetting.input"
            label="Eingabe-Typ"
            item-text="text"
            item-value="input"
            :items="exerciseSettingInputPossibilities"
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input mb-2"></v-select>
          <v-combobox
            v-model="exerciseSetting.selections"
            v-if="exerciseSetting.input && exerciseSetting.input === 'selection'"
            :search-input.sync="selectionPossibilitiesSearch"
            label="Auswahlmöglichkeiten (mit Enter bestätigen)"
            multiple
            small-chips
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input">
            <template v-slot:selection="{ item }">
              <v-chip
                dark
                small
                color="#00E676"
                class="black--text font-weight-bold mt-1 mr-1"
                close
                close-icon="mdi-close-circle"
                @click:close="exerciseSetting.selections.splice(exerciseSetting.selections.indexOf(item), 1)">
                {{ item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey" text small @click="abortSettingForm">Abbrechen</v-btn>
          <v-btn color="#00E676" class="black--text font-weight-bold px-4" depressed small @click="saveGeneralSetting">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="setExerciseSettingsDialog" max-width="600px" dark persistent>
      <v-card color="#1a1a1a" style="border-radius: 8px">
        <v-card-title class="text-h6 font-weight-bold white--text pt-5">Satzeinstellung</v-card-title>
        <v-card-text class="pt-4">
          <v-combobox
            v-model="exerciseSetting"
            :search-input.sync="exerciseSettingSearch"
            item-text="text"
            return-object
            item-value="text"
            label="Was wird pro Satz erfasst? (z.B. Gewicht)"
            :items="availableSetExerciseSettingsFiltered"
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input mb-2"></v-combobox>
          <v-select
            v-if="exerciseSetting.text"
            v-model="exerciseSetting.input"
            label="Eingabe-Typ"
            item-text="text"
            item-value="input"
            :items="exerciseSettingInputPossibilities"
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input mb-2"></v-select>
          <v-combobox
            v-model="exerciseSetting.selections"
            v-if="exerciseSetting.input && exerciseSetting.input === 'selection'"
            :search-input.sync="selectionPossibilitiesSearch"
            label="Auswahlmöglichkeiten (mit Enter bestätigen)"
            multiple
            small-chips
            outlined
            dense
            dark
            background-color="#121212"
            class="modern-input">
            <template v-slot:selection="{ item }">
              <v-chip
                dark
                small
                color="#00E676"
                class="black--text font-weight-bold mt-1 mr-1"
                close
                close-icon="mdi-close-circle"
                @click:close="exerciseSetting.selections.splice(exerciseSetting.selections.indexOf(item), 1)">
                {{ item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="grey" text small @click="abortSettingForm">Abbrechen</v-btn>
          <v-btn color="#00E676" class="black--text font-weight-bold px-4" depressed small @click="saveSetSetting">Hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="400" dark>
      <v-card color="#1a1a1a" style="border-radius: 8px">
        <v-card-title class="text-h6 font-weight-bold white--text pt-5">Wirklich löschen?</v-card-title>
        <v-card-text class="grey--text mt-2"> Möchtest Du "{{ deletingExerciseSetting.text }}" unwiderruflich entfernen? </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text small @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="red" outlined small @click="deleteExerciseSetting(deletingExerciseSetting, 1)">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saveWarningDialog" max-width="400" dark>
      <v-card color="#1a1a1a" style="border-radius: 8px">
        <v-card-title class="text-h6 font-weight-bold white--text pt-5">Achtung!</v-card-title>
        <v-card-text class="grey--text mt-2">Du hast ungespeicherte Änderungen. Trotzdem schließen?</v-card-text>
        <v-card-actions class="pa-4">
          <v-btn color="grey" text small @click="$emit('close')">Verwerfen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#00E676" class="black--text font-weight-bold px-4" depressed small @click="validateForm">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import api from "../../../api"
import { mapGetters, mapActions, mapState } from "vuex"
import Slim from "../../../plugins/slimImage/slim/slim.vue"

export default {
  name: "deviceExerciseForm",
  components: {
    "slim-cropper": Slim,
  },
  data() {
    return {
      slimOptionsExercise: {
        ratio: "4:3",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        dataJpegCompression: 30,
        label: "",
        service: this.uploadPicture,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },
      slimOptionsManual: {
        ratio: "4:3",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        dataJpegCompression: 30,
        label: "",
        service: this.uploadManualImage,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },

      form: {
        _id: null,
        title: "",
        tags: [],
        picture: "",
        general_exercise_settings: [],
        set_exercise_settings: [],
        manual: [],
      },
      oldForm: {},

      exerciseSetting: { text: null, input: null, selections: [] },
      deleteDialog: false,
      saveWarningDialog: false,
      deletingExerciseSetting: { text: "", input: "" },

      selectionPossibilitiesSearch: "",
      exerciseSettingSearch: "",
      exerciseSettingInputPossibilities: [
        { text: "Text", input: "text" },
        { text: "Zahl", input: "number" },
        { text: "Auswahl", input: "selection" },
      ],
      availableExerciseSettings: [
        { text: "Programm", input: "text" },
        { text: "Thema", input: "text" },
        { text: "Level", input: "text" },
        { text: "Dehnmethode", input: "text" },
        { text: "Herzfrequenz", input: "text" },
        { text: "Ausdauermethode", input: "text" },
        { text: "Watt", input: "number" },
        { text: "Geschwindigkeit", input: "number" },
        { text: "Umdrehungen pro Minute", input: "number" },
        { text: "Kalorien", input: "number" },
        { text: "Pause", input: "text" },
        { text: "Dauer", input: "number" },
        { text: "Notiz", input: "text" },
        { text: "Gewicht", input: "number" },
        { text: "Max Wiederholungen", input: "number" },
        { text: "Min Wiederholungen", input: "number" },
        { text: "Sätze", input: "number" },
        { text: "Lehne", input: "number" },
        { text: "Sitz", input: "text" },
        { text: "Winkel", input: "text" },
        { text: "Rolle", input: "text" },
        { text: "Polster", input: "text" },
        { text: "Position", input: "text" },
        { text: "Platte", input: "text" },
        { text: "Wiederstand", input: "text" },
        { text: "Band", input: "text" },
        { text: "Höhe Box", input: "text" },
        { text: "Griffe", input: "text" },
        { text: "Höhe", input: "number" },
        { text: "Ball", input: "text" },
        { text: "Variante", input: "text" },
        { text: "Bandstärke", input: "text" },
        { text: "Pad", input: "text" },
      ],

      generalExerciseSettingsDialog: false,
      setExerciseSettingsDialog: false,
      manualDialog: false,
      deleteType: "",
      loaded: false,
      manualForm: { picture: "", description: "" },
      availableTags: null,
      rules: {
        title: [(v) => !!v || "Dieses Feld wird benötigt", (v) => v.length <= 30 || "Der Titel ist zu lang"],
      },
    }
  },
  async created() {
    this.availableTags = await api.fetchExerciseTags()

    if (this.exerciseEdit) {
      this.form = JSON.parse(JSON.stringify(this.exerciseEdit))
    }

    this.oldForm = JSON.stringify(this.form)
    this.loaded = true
  },
  methods: {
    ...mapActions("deviceStore", ["updateExercise", "createExercise"]),

    checkChanges() {
      if (this.oldForm !== JSON.stringify(this.form)) {
        this.saveWarningDialog = true
      } else {
        this.$emit("close")
      }
    },

    preventReload(event) {
      event.preventDefault()
    },

    validateForm() {
      if (this.$refs.form.validate()) {
        if (this.exerciseEdit) {
          this.updateExercise(this.form)
        } else {
          this.createExercise(this.form)
        }

        this.$emit("close")
      }
    },

    // --- BILDER UPLOADS ---
    uploadPicture(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      let uploadimg = { art: "device_exercise", formData: formData }
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            this.form.picture = data.name
            success(data)
          }
        })
        .catch(failure)
    },

    uploadManualImage(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      let uploadimg = { art: "device_exercise_manual", formData: formData }
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            this.manualForm.picture = data.name
            success(data)
          }
        })
        .catch(failure)
    },

    // --- SCHRITTE (MANUALS) ---
    openManualDialog(index) {
      if (index >= 0) {
        this.manualForm = JSON.parse(JSON.stringify(this.form.manual[index]))
        this.manualForm.index = index
      } else {
        this.manualForm = { picture: "", description: "", index: -1 }
      }
      this.manualDialog = true
    },
    saveManual() {
      if (this.manualForm.index >= 0) {
        let index = this.manualForm.index
        delete this.manualForm.index
        this.$set(this.form.manual, index, this.manualForm)
      } else {
        delete this.manualForm.index
        this.form.manual.push(this.manualForm)
      }
      this.abortManual()
    },
    abortManual() {
      this.manualDialog = false
      this.manualForm = { picture: "", description: "", index: -1 }
    },
    deleteManual() {
      this.form.manual.splice(this.manualForm.index, 1)
      this.abortManual()
    },

    // --- SETTINGS ---
    abortSettingForm() {
      this.generalExerciseSettingsDialog = false
      this.setExerciseSettingsDialog = false
      this.exerciseSetting = { input: null, text: null, selections: [] }
    },
    saveGeneralSetting() {
      if (!this.exerciseSetting.selections || !this.exerciseSetting.selections.length) delete this.exerciseSetting.selections
      this.form.general_exercise_settings.push({ ...this.exerciseSetting })
      this.abortSettingForm()
    },
    saveSetSetting() {
      if (!this.exerciseSetting.selections || !this.exerciseSetting.selections.length) delete this.exerciseSetting.selections
      this.form.set_exercise_settings.push({ ...this.exerciseSetting })
      this.abortSettingForm()
    },
    deleteExerciseSetting(es, status, type) {
      if (status === 0) {
        this.deleteType = type
        this.deletingExerciseSetting = es
        this.deleteDialog = true
      } else {
        if (this.deleteType === "Device") {
          this.form.general_exercise_settings = this.form.general_exercise_settings.filter((setting) => setting.text !== es.text)
        } else {
          this.form.set_exercise_settings = this.form.set_exercise_settings.filter((setting) => setting.text !== es.text)
        }
        this.deleteDialog = false
      }
    },
  },
  computed: {
    ...mapState("deviceStore", ["exerciseEdit"]),

    getManualFormTitle() {
      return this.manualForm.index >= 0 ? `Schritt ${this.manualForm.index + 1} bearbeiten` : "Neuen Schritt hinzufügen"
    },
    availableDeviceExerciseSettingsFiltered() {
      let activated = this.form.general_exercise_settings || []
      return this.availableExerciseSettings.filter((setting) => !activated.find((a) => a.text === setting.text))
    },
    availableSetExerciseSettingsFiltered() {
      let activated = this.form.set_exercise_settings || []
      return this.availableExerciseSettings.filter((setting) => !activated.find((a) => a.text === setting.text))
    },
  },
}
</script>

<style scoped>
.tracking-wide {
  letter-spacing: 1px;
}

/* Modernes Input-Styling */
.modern-input ::v-deep .v-input__slot {
  border-color: #333 !important;
}
.modern-input ::v-deep .v-input--is-focused .v-input__slot {
  border-color: #00e676 !important;
}
/* FIX FÜR DEN SLIM CROPPER (Nur Icons, kein Text) */
.slim-wrapper ::v-deep .slim-btn-group {
  display: flex !important;
  flex-direction: row !important;
  gap: 10px;
  justify-content: center;
}

.slim-wrapper ::v-deep .slim-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: rgba(30, 30, 30, 0.8) !important;
  border-radius: 6px !important;
  width: 40px !important; /* Feste Breite für quadratische Buttons */
  height: 40px !important; /* Feste Höhe */
  padding: 0 !important; /* Padding weg, damit es zentriert ist */
  color: white !important;
}

/* Den Text (span) komplett ausblenden */
.slim-wrapper ::v-deep .slim-btn span {
  display: none !important;
}

/* Margin beim Icon entfernen, da kein Text mehr daneben steht */
.slim-wrapper ::v-deep .slim-btn svg {
  margin: 0 !important;
}
/* Verhindert, dass man beim Scroll-Bounce (Herumschieben) den Hintergrund sieht */
::v-deep .v-dialog--fullscreen {
  background-color: #121212 !important;
}

/* Entfernt jegliche Transparenz aus den Formularen */
.v-dialog .v-card {
  opacity: 1 !important;
}
</style>
